import { render, staticRenderFns } from "./ShipmentCommandQuery.vue?vue&type=template&id=2aa58082&scoped=true"
import script from "./ShipmentCommandQuery.vue?vue&type=script&lang=js"
export * from "./ShipmentCommandQuery.vue?vue&type=script&lang=js"
import style0 from "./ShipmentCommandQuery.vue?vue&type=style&index=0&id=2aa58082&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa58082",
  null
  
)

export default component.exports